<template>
  <div>
    <div class="py-10">
      <v-img src="media/logo/logoTMG.png" max-width="20vh" class="mx-auto mb-5"/>
    </div>
  
    <video-list local-storage-text-key="dashboard-search" local-storage-theme-key="dashboard-theme"/>

    <v-row justify="center" v-if="this.currentUser.previousConnection === null && this.onBoarding">
      <v-dialog
        v-model="onBoardingDialog"
        persistent
        max-width="500"
        transition="dialog-bottom-transition"
      >
        <v-card color="amber lighten-1">
          <div class="d-flex flex-row justify-content-end p-2">
            <i class="fa fa-times-circle" style="color:black" @click="closeModal()" aria-hidden="true"></i>
          </div>
          <div class="d-flex flex-column align-items-center">
            <v-card-title class="text-h5">
              {{$t("modal.welcome")}}
            </v-card-title>
            <v-spacer></v-spacer>
            <v-card-text>
              <br>
              {{$t("modal.textModal1")}}<br><br>
              {{$t("modal.textModal2")}}
              {{$t("modal.textModal3")}}<br>
              {{$t("modal.textModal4")}}<br>
              {{$t("modal.textModal5")}}<br>
              {{$t("modal.textModal6")}}
              {{$t("modal.textModal7")}}<br><br>
              {{$t("modal.textModal8")}}<br><br>
              </v-card-text>
              <v-card-actions>
              <v-spacer></v-spacer>
              <div>
                <img style="top: 282px; left: 235px; position: absolute; z-index: 2; width: 50px;" src="/media/svg/illustrations/TMG-ours-bras-croises.png">
                <router-link :to="{ name: 'videoFromCourse', params: { id: 162, idParcours: 22 } }">
                  <v-btn class="pink lighten-1 mb-4" text @click="closeModal()">
                    {{$t("modal.click")}}
                  </v-btn>
                </router-link>
              </div>
            </v-card-actions>
          </div>

        </v-card>
      </v-dialog>
    </v-row>

  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import VideoList from "@/components/video/videoList";
import store from "@/core/services/store";
import { mapGetters } from "vuex";
import { UPDATE_ON_BOARDING } from "@/core/services/store/auth.module";

export default {
  name: "dashboard",
  data(){
    return{
      onBoardingDialog: true,
    }
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "onBoarding",
    ]),
  },
  components: { VideoList },
  //Appelé au chargement de la page automatiquement
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$i18n.t('breadCrumb.dashboard') }]);
    // console.log(i18nService.getActiveLanguage()); Récupère le langage actif
  },
  methods: {
    closeModal(){
      store.dispatch(UPDATE_ON_BOARDING, false);
    }
  },
  metaInfo: {
    // Les enfants peuvent remplacer le titre.
    title: 'Dashboard',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Dashboard de l\'application TellMeGenius.'}
    ]
  }
};
</script>
